<p>Redirects to keyclock logout Page....</p>